module.exports = __webpack_public_path__ + "img/formPh.20b2072f.svg";